/* eslint-disable */
import schema from '@/components/abertura/schema';
import schemaItem from '@/components/abertura/schemaItem';
import dateHandlerMixin from '@/mixins/dataHandler';
import Vuetify from '@/plugins/vuetify';
import { api, toast } from '@/services';
import { v4 as uuidv4 } from 'uuid';
import Vue from 'vue';
import * as xlsx from 'xlsx';
import * as yup from 'yup';
import downloadAttachment from '../../../utils/downloadAttachment';

export default {
  async fetchSolicitacoesProcesso({ commit, dispatch }, payload) {
    const keys = Object.keys(payload);
    const params = new URLSearchParams();
    /* eslint-disable */
    for (const key of keys) {
      if (payload[key]) {
        params.append(key, payload[key]);
      }
    }
    dispatch('toggleLoading', true, { root: true });
    const response = await api.get('/processo/solicitar', { params: params || [] });
    commit('SET_SOLICITACOES_PROCESSO', response.data.data);
    commit('paginacao/SET_PAGINADOR', response.data, { root: true });
    dispatch('toggleLoading', false, { root: true });
  },
  async fetchNCMByDescricao(_, payload) {
    const { ncm, descricao } = payload;
    const response = await api.get(`/processo/solicitar/ncm-descricao/ ${ncm}/${descricao}`);
    return response;
  },
  async fetchSolicitacoesProcessoAdm({ commit, dispatch }, payload) {
    const keys = Object.keys(payload);
    const params = new URLSearchParams();
    /* eslint-disable */
    for (const key of keys) {
      if (payload[key]) {
        params.append(key, payload[key]);
      }
    }
    dispatch('toggleLoading', true, { root: true });
    const response = await api.get('/processo/solicitar/adm', { params });
    commit('SET_SOLICITACOES_PROCESSO', response.data.data);
    commit('paginacao/SET_PAGINADOR', response.data, { root: true });
    dispatch('toggleLoading', false, { root: true });
  },
  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },
  async cancelarSolicitacao({ dispatch }, payload) {
    const { _id } = payload;
    return api.delete(`/processo/solicitar/${_id}`)
      .then(() => dispatch('fetchSolicitacoesProcesso'));
  },
  criarSolicitacaoProcesso({ commit, dispatch }) {
    commit('SET_SOLICITACAO_PROCESSO', { _rascunhoId: uuidv4() });
    dispatch('abrirModal');
  },
  recuperarRascunho({ state, commit, dispatch }, id) {
    const rascunho = state.rascunhos[id];
    if (!rascunho) {
      throw new Error('Rascunho não encontrado');
    }
    commit('SET_SOLICITACAO_PROCESSO', JSON.parse(rascunho.conteudo));
    dispatch('abrirModal');
  },
  async sendChatMessage(_, payload) {
    if (payload.type === 'processo') {
      return api.post(`/processo/chat`, payload).then((response) => response.data);
    }

    return api.post(`/processo/solicitar/chat`, payload).then((response) => response.data);
  },
  async getMessagesChat(_, payload) {
    const params = new URLSearchParams();

    if (payload.tipo === 'processo') {
      params.append('referenciaCliente', payload.referencia);

      return api.get('/processo/chat', { params }).then((response) => response.data);
    }

    params.append('referenciaCliente', payload);

    return api.get('/processo/solicitar/listar/chat', { params }).then((response) => response.data);
  },
  async editarSolicitacaoProcesso({ commit, dispatch, rootGetters }, payload) {
    const { _id } = payload;

    const solicitacaoProcesso = await api.get(`/processo/solicitar/${_id}`).then((response) => response.data);

    commit('SET_SOLICITACAO_PROCESSO', solicitacaoProcesso);

    const hasAlteracoes = await dispatch('sap_alteracoes/fetchAlteracoes', solicitacaoProcesso, { root: true });

    if (hasAlteracoes.length && rootGetters['Auth/isUsuarioTrust'] && solicitacaoProcesso.emAlteracao) {
      commit('SET_EM_ALTERACAO', true);

      toast.clear();
      toast.warn(Vuetify.framework.lang.t('$vuetify.solicitacaoAlteracaoPendente'));
    } else {
      dispatch('abrirModal');
    }

    if (!rootGetters['Auth/isUsuarioTrust'] && payload.referenciaTrust !== '-') {
      commit('SET_PROCESSO_VISUALIZACAO', true);
      commit('SET_PROCESSO_ALTERACAO', true);
    }

    return solicitacaoProcesso;
  },
  async verSolicitacaoProcesso({ commit, dispatch, rootGetters }, payload) {
    const { _id } = payload;

    const solicitacaoProcesso = await api.get(`/processo/solicitar/${_id}`)
      .then((response) => response.data);

    commit('SET_SOLICITACAO_PROCESSO', solicitacaoProcesso);
    dispatch('abrirModalVisualizacao');

    if (!rootGetters['Auth/isUsuarioTrust'] && payload.referenciaTrust !== '-') {
      commit('SET_PROCESSO_VISUALIZACAO', true);
      commit('SET_PROCESSO_ALTERACAO', true);
    }

    if (solicitacaoProcesso.emAlteracao) {
      toast.clear();
      toast.warn(Vuetify.framework.lang.t('$vuetify.solicitacaoAlteracaoPendente'));
    }

    return solicitacaoProcesso;
  },
  carregarTemplateSolicitacaoProcesso({ commit, getters, rootGetters }, arquivo) {
    if (!arquivo) {
      return;
    }

    const reader = new FileReader();
    reader.readAsArrayBuffer(arquivo);
    reader.onload = () => {
      const data = new Uint8Array(reader.result);
      const workbook = xlsx.read(data, {type: 'array'});
      const folhaGeral = workbook.Sheets[workbook.SheetNames[0]];
      const folhaItens = workbook.Sheets[workbook.SheetNames[1]];
      const quantidadeItens = folhaItens ? xlsx.utils.decode_range(folhaItens['!ref']).e.r : 0;

      const popular = (campos, folha, linha) => {
        const output = {};

        for (let i = 0; i < campos.length; i++) {
          const campo = campos[i];
          const ref = xlsx.utils.encode_cell({ c: i, r: linha});
          const cell = folha[ref];

          if (typeof campo === 'string') {
            output[campos[i]] = cell?.v?.toString().trim() || null;
          }

          if (typeof campo === 'object' && campo.type === Number) {
            output[campos[i].campo] = cell?.v || null;
          }
        }
        return output;
      }

      const payload = popular([
        'referenciaCliente',
        { campo: 'tipoImportacaoId', type: Number },
        'finalidade',
        'importador',
        'ctEmpresasCNPJ',
        'incoterm',
        'eta',
        'observacao',
      ], folhaGeral, 1);

      Object.assign(payload, { statusSolicitacao: 1 });

      const exportadores = getters.getExportadores;
      const exportadorValido = exportadores.find((exportador) => exportador.NOME_EXPORTADOR === payload.ctEmpresasCNPJ);

      if (!exportadorValido) {
        payload.ctEmpresasCNPJ = null;
      }

      const importadores = rootGetters['Auth/getEmpresasSelecionadasNomeCNPJ'];
      const importadorValido = importadores.find((empresa) => empresa.cnpj === payload.importador);

      if (!importadorValido) {
        payload.importador = null;
      }

      const erros = [];

      try {
        schema.validateSync(payload, { abortEarly: false });
      } catch (e) {
        erros.push(...e.inner);
      }

      const itens = [];

      for (let i = 1; i <= quantidadeItens; i++) {
        const item = popular(['NCM', 'UNIDADE_MEDIDA', 'QUANTIDADE', 'MOEDA', 'DESCRICAO', 'VALOR_UNITARIO'], folhaItens, i);
        item.TOTAL = item.QUANTIDADE * item.VALOR_UNITARIO;
        item.key = uuidv4();

        try {
          schemaItem.validateSync(item, { abortEarly: false });
          itens.push(item);
        } catch (e) {
          erros.push(e.inner);
          erros.push(`${i+1}º item não foi inserido`);
        }
      }

      erros.forEach(erro => {
        toast.warn(erro.message);
      });
      Object.assign(payload, { itens });

      commit('SET_SOLICITACAO_PROCESSO', payload);
    }
  },
  async reenviarEmail(_, id) {
    await api.post(`/processo/solicitar/reenviar-email/${id}`);
    Vue.$toast.success('Email reenviado com sucesso');
  },
  validarReferenciaCliente(_, payload) {
    const {
      referenciaCliente,
      ct_empresas_id: empresaId,
    } = payload;
    return api.get(`/processo/solicitar/referencia_cliente?ct_empresas_id=${empresaId}&referencia_cliente=${referenciaCliente}`);
  },
  limparSolicitacaoProcesso({ commit }) {
    commit('SET_SOLICITACAO_PROCESSO', {});
  },
  async salvar({ dispatch, rootGetters }, payload) {
    try {
      const solicitacaoProcesso = await schema.validate(payload, {
        abortEarly: false,
      });

      const {
        _id,
        itens,
        arquivos,
        ...processo
      } = solicitacaoProcesso;

      if (!processo.etd) {
        processo.etd = '';
      }

      const formData = new FormData();

      Object.entries(processo).forEach(([key, value]) => {
        formData.append(key, value);
      });

      if (Array.isArray(itens) && itens.length) {
        Object.entries(itens).forEach(([, value], i) => {
          Object.entries(value).forEach(([key, item]) => {
            formData.append(`itens[${i}].${key}`, item);
          });
        });
      }

      if (Array.isArray(arquivos) && arquivos.length) {
        Object.entries(arquivos).forEach(([, value], i) => {
          const { arquivo, ...metadata } = value;
          formData.append(`arquivo[${i}]`, arquivo);
          Object.entries(metadata).forEach(([key, item]) => {
            formData.append(`arquivos[${i}].${key}`, item);
          });
        });
      }

      let endpoint;
      let method;

      if (_id) {
        endpoint = `/processo/solicitar/${_id}`;
        method = 'put';
      } else {
        endpoint = '/processo/solicitar';
        method = 'post';
      }

      const response = await api[method](endpoint, formData, {
        headers: {
          'Content-Type': 'multiform/form-data',
        },
      });

      dispatch('limparSolicitacaoProcesso');

      // todo - ENUMS
      if (rootGetters['Auth/isUsuarioTrust']) {
        dispatch('fetchSolicitacoesProcessoAdm', { page: 1, perPage: 20 });
      } else {
        dispatch('fetchSolicitacoesProcesso', { page: 1, perPage: 20 });
      }

      dispatch('fecharModal');

      return response.data;
    } catch (e) {
      return e.inner;
    }
  },
  async downloadArquivo(ctx, arquivo) {
    const { _id } = arquivo;
    return api.get(`/processo/solicitar/download/${_id}`, {
      responseType: 'blob',
    })
      .then((response) => {
        const blob = response.data;
        const nomeArquivo = response.headers['x-suggested-filename'];
        downloadAttachment(blob, nomeArquivo);
      });
  },
  async fetchTiposProcesso({ commit }) {
    return api.get('/conexos/tipos_processo')
      .then((response) => {
        commit('SET_TIPOS_PROCESSO', response.data.registros);
      });
  },
  async fetchSituacoesSolicitacao({ commit }) {
    return api.get('/conexos/status_solicitacao_processo')
      .then((response) => {
        commit('SET_STATUS_SOLICITACAO_PROCESSO', response.data.registros);
      });
  },
  async fetchTiposDocumento({ commit }) {
    return api.get('/processo/solicitar/tipos_documento')
      .then((response) => {
        commit('SET_TIPOS_DOCUMENTO', response?.data?.registros || []);
      });
  },
  async gerarOrdem({ dispatch }, ordem) {
    if (ordem._id) {
      await api.put(`/ordem-compra/${ordem._id}`, ordem);
    } else {
      await api.post('/ordem-compra', ordem);
    }
    Vue.$toast.success('Ordem de compra gerada com sucesso!');
    dispatch('baixarOrdem');
  },
  async getEnderecoEmpresa(_, nome) {
    return api.get(`/empresa/${nome}`);
  },
  baixarOrdem({ commit }) {
    commit('ATIVAR_DOWNLOAD_ORDEM');
  },
  fecharBaixarOrdem({ commit }) {
    commit('DESATIVAR_DOWNLOAD_ORDEM');
  },
  baixarProcesso({ commit }) {
    commit('ATIVAR_DOWNLOAD_PROCESSO');
  },
  fecharBaixarProcesso({ commit }) {
    commit('DESATIVAR_DOWNLOAD_PROCESSO');
  },
  async getOrdemCompra({ state }, payload) {
    const result = await api.get(`/ordem-compra/${payload}`);
    if (result.data.registros.length > 0) {
      return result.data.registros[0];
    }
    return state.modeloOrdemCompra;
  },
  abrirModal({ commit }) {
    commit('ABRIR_MODAL');
  },
  abrirModalVisualizacao({ commit }) {
    commit('ABRIR_MODAL_VISUALIZACAO');
  },
  fecharModalVisualizacao({ commit }) {
    commit('FECHAR_MODAL_VISUALIZACAO');
  },
  abrirModalOrdem({ commit }) {
    commit('ABRIR_MODAL_ORDEM');
  },
  fecharModalOrdemCompra({ commit }) {
    commit('FECHAR_MODAL_ORDEM');
  },
  fecharModal({ dispatch, commit }) {
    dispatch('limparSolicitacaoProcesso');
    commit('SET_PROCESSO_VISUALIZACAO', false);
    commit('SET_PROCESSO_ALTERACAO', false);
    commit('SET_EM_ALTERACAO', false);
    commit('FECHAR_MODAL');
  },
  async fetchExportadores({ commit }) {
    const { data } = await api.get('processo/exportadores');

    data.unshift({ NOME_EXPORTADOR: 'OUTROS (INFORMAR NAS OBSERVAÇÕES)'});

    commit('SET_EXPORTADORES', data);
  },
  async encaminharSolicitacaoEmail(_, { _id, emails }) {
    const schema = yup.array(
      yup.string(Vuetify.framework.lang.t('$vuetify.emailInvalido'))
        .email(Vuetify.framework.lang.t('$vuetify.emailInvalido'))
        .min(1, Vuetify.framework.lang.t('$vuetify.requiredFieldEmail'))
        .required(Vuetify.framework.lang.t('$vuetify.requiredFieldEmail'))
        .nullable());

    try {
      const payload = schema.validateSync(emails);

      return api.post(`/processo/solicitar/reenviar-email/${_id}`, payload);
    } catch(e) {
      Vue.$toast.error(e.message);
    }
  },
  async prepararExcel({ getters }, isAdmTrust) {
    const listaItens = getters.getSolicitacoesProcesso;

    if (!getters.getSolicitacoesProcesso) {
      response = await api.get(`/processo/solicitar/excel/${isAdmTrust}`);
      listaItens = response.data;
    }

    const solicitacoesFormatadas = listaItens.map((sap) => {
      return {
        referenciaCliente: sap.referenciaCliente,
        referenciaTrust: sap.referenciaTrust,
        status: sap.status,
        usuario: sap.usuario,
        tipoImportacao: sap.tipoImportacao,
        finalidade: sap.finalidade,
        empresaImportador: sap.empresaImportador,
        dataSolicitacao: dateHandlerMixin.methods.formatDateComHora(sap.dataSolicitacao),
        updatedAt: dateHandlerMixin.methods.formatDateComHora(sap.updatedAt),
      }
    });

    return solicitacoesFormatadas;
  },
  salvarRascunho({ commit }, solicitacaoProcesso) {
    const { _rascunhoId, referenciaCliente } = solicitacaoProcesso;
    if (!_rascunhoId) {
      return;
    }
    /**
     * por enquanto, não vou pensar sobre minificar arquivos
     */
    const processoJSON = JSON.stringify({ ...solicitacaoProcesso, arquivos: [] });
    commit('ADICIONAR_RASCUNHO', { _rascunhoId, conteudo: processoJSON, referenciaCliente } );
  },
};
